"use strict";

const PageNav = () => {
    const init = () => {
        $(function() {
            var $navContainer = $('.js-page-nav');
            if ($navContainer.length > 0) {
                var $navModule = $navContainer.find('.js-page-nav-module');
                var $navLinks = $navContainer.find('.js-page-nav-link');
                var $sections = $navContainer.find('[data-section]');
                var $borders = $navContainer.find('.borders');

                $navLinks.on('click', function(){
                    var $section = $sections.filter('[data-section="'+$(this).data('id')+'"]');
                    if($section.length > 0) {
                        $('html, body').animate({
                            scrollTop: $section.offset().top - $navModule.outerHeight() - $('.js-navbar').outerHeight()
                        }, 100);
                    }
                });

                var lastScrollPosition = 0;

                $(window).on('scroll', function(){
                    var scrollPosition = $(this).scrollTop()
                    if(scrollPosition >= lastScrollPosition){
                        $($sections.get().reverse()).each(function(){
                            if(scrollPosition + $(window).outerHeight() >= $(this).offset().top + ($(this).outerHeight() / 2) - $navModule.outerHeight()) {
                                $navLinks.removeClass('active');
                                $navLinks.filter('[data-id="'+$(this).data('section')+'"]').addClass('active');
                                $(this).find('.aos-init').addClass('aos-animate');
                                $borders.animate({
                                    scrollLeft: $navLinks.filter('[data-id="'+$(this).data('section')+'"]').offset().left + $borders.scrollLeft() - 20
                                }, 0);
                                return false;
                            }
                        });
                    } else {
                        $sections.each(function(){
                            if(scrollPosition <= $(this).offset().top + $(this).outerHeight() - $navModule.outerHeight()) {
                                $navLinks.removeClass('active');
                                $navLinks.filter('[data-id="'+$(this).data('section')+'"]').addClass('active');
                                $(this).find('.aos-init').addClass('aos-animate');
                                $borders.animate({
                                    scrollLeft: $navLinks.filter('[data-id="'+$(this).data('section')+'"]').offset().left + $borders.scrollLeft() - 20
                                }, 0);
                                return false;
                            }
                        });
                    }
                    lastScrollPosition = scrollPosition;
                });
            }
        });
    };

    return {
        init:init
    };
};

export default PageNav;